<template>
  <router-view :key="'profile_' + $route.path" />
</template>
<script>
export default {
  mounted() {
    this.$store.state.breadcrumbs = {
      title: "Profiel",
      links: [
        {
          title: "Vereniging",
          href: "/community",
        },
        {
          title: "Leden",
          href: "/community/members",
        },
      ],
    };
    if (this.$route.params.id) {
      this.$store
        .dispatch("get", "api/v1/users/" + this.$route.params.id)
        .then((data) => {
          this.$store.commit("addUserBreadcrumb", { ...data.data.data });

          if (this.$route.meta.Breadcrumb) {
            this.$store.commit("addBreadcrumb", {
              title: this.$route.meta.Breadcrumb,
              href: this.$route.path,
            });
          }
        });

      let menus = [];

      if (
        this.userHasPermissions(
          ["Ledenadministratie"],
          this.$route.params.id == this.$store.state.auth.user.id
        )
      ) {
        menus.push({
          title: "Profiel",
          href: "/profile/" + this.$route.params.id + "/view",
          children: [],
        });
      }

      if (
        this.userHasPermissions(
          ["Ledenadministratie"],
          this.$route.params.id == this.$store.state.auth.user.id
        ) &&
        this.$route.params.id == this.$store.state.auth.user.id
      ) {
        menus.push({
          title: "Privacy",
          href: "/profile/" + this.$route.params.id + "/privacy",
          children: [],
        });
      }

      if (this.userHasPermissions(["Ledenadministratie"])) {
        menus.push({
          title: "Commissies",
          href: "/profile/" + this.$route.params.id + "/committees",
          children: [],
        });
      }

      if (this.userHasPermissions(["Ledenadministratie"])) {
        menus.push({
          title: "Groepen",
          href: "/profile/" + this.$route.params.id + "/groups",
          children: [],
        });
      }

      if (this.userHasPermissions(["Ledenadministratie", "Financieel"])) {
        menus.push({
          title: "Abonnementen",
          href: "/profile/" + this.$route.params.id + "/subscriptions",
          children: [],
        });
      }

      if (this.userHasPermissions(["Ledenadministratie", "Financieel"])) {
        menus.push({
          title: "Betalingen",
          href: "/profile/" + this.$route.params.id + "/payments",
          children: [],
        });
      }

      if (this.userHasPermissions(["Ledenadministratie"])) {
        menus.push({
          title: "Rechten",
          href: "/profile/" + this.$route.params.id + "/permissions",
          children: [],
        });
      }
      if (
        this.userHasPermissions(["Ledenadministratie"]) ||
        this.$store.state.auth.user.id == this.$route.params.id
      ) {
        menus.push({
          title: "Wachtwoord",
          href: "/profile/" + this.$route.params.id + "/password",
          children: [],
        });
      }

      /* if(this.userHasPermissions([''])) {
					menus.push({
						'title' : 'Mijn taken',
					   	'href' 	: '/profile/'+this.$route.params.id+'/responsibilities',
					 	'children': [],
					})
				} */

      /* if(this.userHasPermissions([''])) {
					menus.push({
						'title' : 'Mijn itemgroepen',
					 	'href' 	: '/profile/'+this.$route.params.id+'/itemgroups',
					 	'children': [],
					})
				} */

      /* if(this.userHasPermissions([''])) {
					menus.push({
						'title' : 'Mijn items',
					 	'href' 	: '/profile/'+this.$route.params.id+'/items',
					 	'children': [],
					})
				} */

      
      if(!this.$route.path.includes("messages")){
        this.$store.state.inner_sidebar = menus;
      }
    } else {
      this.$store.state.inner_sidebar = [];

      if (this.$route.meta.Breadcrumb) {
        this.$store.commit("addBreadcrumb", {
          title: this.$route.meta.Breadcrumb,
          href: this.$route.path,
        });
      }
    }
  },
};
</script>
